import { CustomSettingsInterface } from 'client/Interfaces/CustomSettingsInterface'
import * as moment from 'moment'

import { CustomerInterface } from '../CustomerInterface'
import { EmailTemplateInterface } from '../EmailTemplateInterface'
import { OrderDraftInterface } from '../OrderInterface'
import { RecurringProfileSettingsInterface } from '../RecurringProfileInterface'
import { PaymentMeanInterface } from '../Settings/PaymentMeanInterface'
import { SettingsTemplateStylesInterface } from '../Settings/SettingsInterface'
import { TradeNameInterface } from '../Settings/TradeNameInterface'
import { ValidationFieldsInterface } from '../ValidationFieldsInterface'
import { InvoiceItemType } from './DraftItemType'
import { DraftFieldsInterface } from './FieldsInterface'

// The interface of the invoice document numbers (called via /number endpoint)
export interface InvoiceDocumentNumberType {
  prefix: string | null
  base: number
  next?: number
  userDefined?: boolean
  active?: boolean
}

// The interface of the property invoiceNumber of the draft document
export interface DocumentNumberType {
  prefix: string | null
  number: number | string
}

export enum DocumentTypes {
  INVOICE = 'invoice',
  RECEIPT = 'receipt',
  ESTIMATE = 'estimate',
  CREDITNOTE = 'creditnote',
  DELIVERYNOTE = 'deliverynote',
  RECEIPTDRAFT = 'receiptDraft',
  DELIVERYNOTEDRAFT = 'deliverynoteDraft',
}

export type DocumentType =
  | DocumentTypes.INVOICE
  | DocumentTypes.RECEIPT
  | DocumentTypes.ESTIMATE
  | DocumentTypes.CREDITNOTE
  | DocumentTypes.DELIVERYNOTE

export enum InvoiceTypes {
  SALES_HOUSEHOLD_SE_ROT = 10,
  SALES_HOUSEHOLD_SE_RUT = 11,
}
export interface InvoicerInterface {
  tradeName: TradeNameInterface
  vatNumber: string
  isNotVATLiable?: boolean
  rcs?: string
  legalStatus?: string
  businessId?: string
  id: number
  amtsgericht?: string
  firmenbuchregister?: string
  taxPrepaymentRegistered?: boolean
  hrNr?: string
}

export interface CharacterLimitInterface {
  description: boolean
  textFields: boolean
}

export interface DraftInterface {
  id?: number
  legacyInvoiceId?: number
  preview?: string[]
  toBeApproved?: boolean
  invoicer?: InvoicerInterface
  receiver?: CustomerInterface
  fields?: DraftFieldsInterface
  summary?: {
    currency: string
    grossTotal: number
    netTotal: number
    taxTotal: number
    reductionTotal?: number
    subTotal: number
    workTotal?: number
    localReductionTotal?: number
    localWorkTotal?: number
    foreignReductionTotal?: number
    foreignWorkTotal?: number
    foreignGrossTotal?: number
    foreignNetTotal?: number
    foreignTaxTotal?: number
    localGrossTotal?: number
    localNetTotal?: number
    localTaxTotal?: number
    discountTotal: number
    taxSummary: Array<{ percentage: number; amount: number }>
  }
  invoiceNumber?: DocumentNumberType
  receiptNumber?: DocumentNumberType
  deliveryNoteNumber?: DocumentNumberType
  paymentMeans?: PaymentMeanInterface[]
  document: DocumentType
  model?: string
  styles?: SettingsTemplateStylesInterface
  lines?: InvoiceItemType[]
  emailTemplate?: EmailTemplateInterface
  invalidFields?: string[]
  isDirty?: boolean
  editInvoice?: boolean
  invoiceId?: number
  estimateId?: number
  order?: OrderDraftInterface
  recurringProfile?: RecurringProfileSettingsInterface
  issueDate?: any
  validationFields?: ValidationFieldsInterface
  customSettings?: CustomSettingsInterface
  eInvoiceSending?: boolean
  characterLimitReached?: CharacterLimitInterface
}
